// custom-radio.js
(function () {
  // We target the ID #bcpo directly as it's the primary wrapper for this app
  const CONTAINER_SELECTOR = '.bcpo'; 
  const HIDDEN_INPUT_ID = 'selected-radio-id';
  let isInitialized = false;

  function getCheckedRadioIn(container) {
    // We use the specific paths from your CSS to find the checked input
    // This looks for checked inputs inside the images or colors sub-containers

    const el = document.querySelector(
      'div[data-unique="_7c4pcbei1"] :is(.bcpo-images input:checked, .bcpo-colors input:checked, input[type="radio"]:checked)'
    );

    return el;

    //return container.querySelector('.bcpo-images input:checked, .bcpo-colors input:checked, input[type="radio"]:checked');
  }

  // 1. Store the reference in a variable outside the function scope
  let currentActiveEl = null;
  function updateHidden(container) {
    //const hidden = document.getElementById(HIDDEN_INPUT_ID);
    //if (!hidden) return;
    
    const checked = getCheckedRadioIn(container);
    if(!checked) {
        // alert("Radio Button is NULL!");
    }
    else {
      function updateVisibility(checkedValue) {
          const id = '#bespoke_button_desc_' + checkedValue
            .replaceAll(' ', '_')
            .replaceAll('(', '_')
            .replaceAll(')', '_')
            .replaceAll('/', '_');
          const el = document.querySelector(id);

          // 2. Check if the element exists
          if (el) {
              // 3. If there was a previous element, hide it
              if (currentActiveEl) {
                  currentActiveEl.style.display = 'none';
              }

              // 4. Make the new element visible
              el.style.display = 'block'; // or 'inline-block', etc.

              // 5. Update the variable to store the new element for next time
              currentActiveEl = el;
          }
      }
      updateVisibility(checked.value);
    }
  }

  function initForContainer(container) {
    if (!container || isInitialized) return;

    // Initial check
    updateHidden(container);

    // The app might stop propagation of 'change' events. 
    // We listen on the container to catch everything bubbling up.
    container.addEventListener('change', (e) => {
      if (e.target.tagName === 'INPUT') {
        updateHidden(container);
      }
    });

    isInitialized = true;
  }

  const observer = new MutationObserver((mutations, obs) => {
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (container) {
      // Check if the internal app content (the actual radios) has loaded
      const hasContent = container.querySelector('input');
      if (hasContent) {
        initForContainer(container);
        // We don't always disconnect in Shopify because apps 
        // often re-render the whole block when variants change.
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();